import {
  type CartItem,
  DELIVERY_OPTIONS,
  type DeliveryKey,
  FREE_SHIPPING_MIN_TOTAL,
  formatMoney,
  labelOf,
  orderTotal,
} from '@c214/shared';
import { FreeShippingBar } from '../ui/free-shipping-bar';

export function OrderSummary({
  items,
  deliveryKey,
}: {
  items: CartItem[];
  deliveryKey: DeliveryKey;
}) {
  const itemsTotal = items.reduce((sum, item) => sum + item.unitPrice * item.qty, 0);
  const delivery = DELIVERY_OPTIONS.find((option) => option.key === deliveryKey);
  const shipping = itemsTotal >= FREE_SHIPPING_MIN_TOTAL ? 0 : (delivery?.cost ?? 0);
  const total = orderTotal(items, deliveryKey);

  return (
    <aside className="self-start border border-line bg-surface p-6">
      <p className="mono-label mb-4">ВАШЕ ЗАМОВЛЕННЯ</p>
      <FreeShippingBar itemsTotal={itemsTotal} />
      <div className="space-y-2">
        {items.map((item) => (
          <div key={item.key} className="flex justify-between text-[14px] text-ink">
            <span>
              {item.name} × {item.qty}
            </span>
            <span>{formatMoney(item.unitPrice * item.qty)}</span>
          </div>
        ))}
      </div>
      <div className="mt-4 flex justify-between border-t border-line pt-4 text-[14px] text-muted">
        <span>{labelOf(DELIVERY_OPTIONS, deliveryKey)}</span>
        <span>{formatMoney(shipping)}</span>
      </div>
      <div className="mt-4 flex justify-between border-t border-line pt-4 text-[22px] font-extrabold text-ink">
        <span>Разом</span>
        <span>{formatMoney(total)}</span>
      </div>
    </aside>
  );
}
